import { Stack, Typography } from '@healthinal/ui';
import { ReactNode } from 'react';

export function CardRow({
  title,
  content,
  children,
  titleFlex = 2,
  contentFlex = 3,
}: {
  title: string;
  content?: string;
  children?: ReactNode;
  titleFlex?: number;
  contentFlex?: number;
}) {
  return (
    <Stack direction={'row'} gap={2}>
      <Typography flex={titleFlex} level={'title-sm'}>
        {title}
      </Typography>
      {children ?? (
        <Typography flex={contentFlex} level={'title-sm'}>
          {content}
        </Typography>
      )}
    </Stack>
  );
}
